import { useEffect } from 'react';

export const useFavicon = () => {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const updateFavicon = (isDark: boolean) => {
      const link = document.querySelector(
        "link[rel~='icon']",
      ) as HTMLLinkElement;
      if (link) {
        link.href = isDark
          ? '/assets/images/favicon.ico'
          : '/assets/images/NapsterLogoBlack.ico';
        console.log('link.href', link.href);
      }
    };

    updateFavicon(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => updateFavicon(e.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);
};
